import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Star',
  props: {
    fill: {
      type: String,
      default: 'var(--icon-fill-secondary)',
    },
    size: {
      type: [String, Number],
      default: 13,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M6.30877 0L8.11013 4.15408L12.6175 4.58359L9.22343 7.58046L10.2078 12L6.30877 9.69808L2.40974 12L3.39412 7.58046L0 4.58359L4.50742 4.15408L6.30877 0Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})